export const PUBLICO_GENERAL_RFC = 'XAXX010101000';
